/**
 * Styles module
 */

import { getWebflowGlobalStyles } from './webflow-styles';
import { getComponentStyles } from './component-styles';
import { getPartnerStyles } from './partner-styles';

/**
 * Gets all styles for the widget.
 * Partner styles come last so their `.is-partner` overrides win; they only apply
 * when the layout adds that class to the widget root.
 */
export function getStyles(): string {
  const webflowGlobalStyles = getWebflowGlobalStyles();
  const componentStyles = getComponentStyles();
  const partnerStyles = getPartnerStyles();

  return `
${webflowGlobalStyles}

${componentStyles}

${partnerStyles}
`;
}

export { injectCSS } from './injector';
